// Centralized mapping for IFI Job Paperwork template types.
// This reduces drift between template dropdown options and warning display labels.

export const JOB_PAPERWORK_TEMPLATE_LABELS = {
  window_worksheet: 'Window Worksheet',
  entry_door_worksheet: 'Entry Door Worksheet',
  storm_door_worksheet: 'Storm Door Worksheet',
  interior_door_worksheet: 'Interior Door Worksheet',
  workorder_inspection: 'Workorder Inspection',
};

export const JOB_PAPERWORK_TEMPLATE_OPTIONS = {
  Assessment: [
    { value: 'window_worksheet', label: JOB_PAPERWORK_TEMPLATE_LABELS.window_worksheet },
    { value: 'entry_door_worksheet', label: JOB_PAPERWORK_TEMPLATE_LABELS.entry_door_worksheet },
    { value: 'storm_door_worksheet', label: JOB_PAPERWORK_TEMPLATE_LABELS.storm_door_worksheet },
    { value: 'interior_door_worksheet', label: JOB_PAPERWORK_TEMPLATE_LABELS.interior_door_worksheet },
  ],
  Workorder: [
    { value: 'workorder_inspection', label: JOB_PAPERWORK_TEMPLATE_LABELS.workorder_inspection },
  ],
};

// Shared "completed" (active, non-retired) template filter, also used by JobPaperworkWarning.
export function getCompletedTemplates(templates) {
  return Array.isArray(templates) ? templates.filter(t => t.document_upload_id && !t.not_use) : [];
}

// "Custom work" is signaled by the presence of any row in a template's Additional
// Labor/Material section (LaborMaterial.jsx), stored as template_data.labors_materials.
export function templateHasCustomLaborMaterial(template) {
  const laborsMaterials = (template.template_data && template.template_data.labors_materials) || [];
  return laborsMaterials.length > 0;
}

export function phaseHasCustomWork(templates) {
  return getCompletedTemplates(templates).some(templateHasCustomLaborMaterial);
}

export const CUSTOM_WORK_CONFIRM_TITLE_NEEDS_CUSTOM = 'Detail Complete Needs Custom Work';
export const CUSTOM_WORK_CONFIRM_TITLE_NO_CUSTOM = 'Detail Complete No Custom Work';
export const CUSTOM_WORK_CONFIRM_BODY =
  'STOP! Did you complete the Custom Labor Q&A? Did you answer the Lead Question/Kit ' +
  'info if applicable? Are all appropriate Templates completed? If yes, Click OK to continue.';



// WEBPACK FOOTER //
// ./client/app/screens/main/screens/phases/phaseShow/components/jobPaperworkTemplateTypes.js